module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainQuestionText),
      expression: "scenario.parameters.mainQuestionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.mainQuestionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('mainQuestionId', 'mainQuestionAudio', 'currentSpeakerMain', 'mainGeneratedAudio', 'mainQuestionText', 'mainLoading', 'Main question', 'currentEmotionMain', 'currentSpeedMain')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.mainLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n            Сгенерировать аудио\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerMain),
      expression: "tmp.currentSpeakerMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                " + _vm._s(speaker.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionMain),
      expression: "tmp.currentEmotionMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                " + _vm._s(emotion.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedMain,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedMain = $event
      }
    }
  }), _vm._v("\n            Скорость: " + _vm._s(_vm.tmp.currentSpeedMain) + "\n          ")], 1), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('mainLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mainLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('mainLoadedAudio', 'mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question', 'mainPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.mainQuestionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'mainGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе да")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), (_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesText),
      expression: "scenario.parameters.onYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onYesId', 'onYesAudio', 'currentSpeakerYes', 'onYesGeneratedAudio', 'onYesText', 'onYesLoading', 'Yes question', 'currentEmotionYes', 'currentSpeedYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.onYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerYes),
      expression: "tmp.currentSpeakerYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionYes),
      expression: "tmp.currentEmotionYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedYes = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedYes) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onYesLoadedAudio', 'onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question', 'onYesPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'onYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.onYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesSMSText),
      expression: "scenario.parameters.onYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('p')], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе нет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoText),
      expression: "scenario.parameters.onNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onNoId', 'onNoAudio', 'currentSpeakerNo', 'onNoGeneratedAudio', 'onNoText', 'onNoLoading', 'No question', 'currentEmotionNo', 'currentSpeedNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.onNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerNo),
      expression: "tmp.currentSpeakerNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionNo),
      expression: "tmp.currentEmotionNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedNo = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedNo) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onNoLoadedAudio', 'onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question', 'onNoPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'onNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd61748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/ScenarioQuestionYesNo.vue
// module id = 431
// module chunks = 40